import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Badge, Box, Divider, IconButton, List, ListItem, Popover, Stack } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import useMyMApi from '../../hooks/useMyMApi';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMLink } from '../../ui-elements/MyMLink';
import { MyMTooltip } from '../../ui-elements/MyMToolTip';
import { utility } from '../../utility';



// MyMine Version2.0 Notification機能追加
/** 
 * HeaderBarUserNotify Component
 */
export const HeaderBarUserNotify = (props) => {
  const { screenId, controlSettings, userNotifyList } = props;
  const [userNotifyListState, setUserNotifyListState] = useState([...userNotifyList]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const notifyAreaRef = useRef();
  const notifyIconRef = useRef();
  const apiRequest = useMyMApi(screenId);
  const lastOpenedNotifydDate = useRef();

  /**
   * Notifyアイコン押下イベント
   */
  const onClickNotifyImage = (event) => {
    // 通知エリア表示
    setAnchorEl(event.currentTarget);

    // 通知を開いてから既読判定を行うまでのミリ秒数
    const ReadNotifyJudgeMs = 3000;
    lastOpenedNotifydDate.current = new Date();
    setTimeout(() => {
      const currentDate = new Date();
      if (currentDate - lastOpenedNotifydDate.current >= ReadNotifyJudgeMs) {
        // 既読判定
        updateReadStatus()
      }
    }, ReadNotifyJudgeMs);
  };

  /**
   * NotifyPopoverを閉じる
   */
  const closeNotify = () => {
    setAnchorEl(null);
  };

  /**
   * Notifyの既読ステータス判定・更新処理
   */
  const updateReadStatus = () => {
    // Notify件数分判定・更新
    document.querySelectorAll('.notification-item').forEach((item, index) => {
      // 既に既読済みのNotifyはなにもしない
      if (userNotifyListState[index].IsRead)
        return;

      // 通知表示領域の下座標 >= 対象通知の下座標の場合、既読と判定
      if (notifyAreaRef.current.getBoundingClientRect().bottom >= item.getBoundingClientRect().bottom) {
        userNotifyListState[index].IsRead = true;
        apiRequest.requestJson('api/notification/read', 'POST', null, null, { 'notificationId': userNotifyListState[index].NotificationId });
        setUserNotifyListState([...userNotifyListState])
      }
    });
  }

  useEffect(() => {

    /**
     * mousedownイベント
     */
    const handleScreenClick = (event) => {
      // クリック要素が通知領域外の場合、通知を閉じる
      if (notifyAreaRef?.current &&
        !notifyAreaRef.current.contains(event.target) &&
        !notifyIconRef.current.contains(event.target)) {
        setAnchorEl(null);
      }
    };

    document.addEventListener('mousedown', handleScreenClick);

    return () => {
      document.removeEventListener('mousedown', handleScreenClick);
    };

  }, []);

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-block',
        ':hover': { cursor: 'pointer' },        
      }}
    >
      <Box ref={notifyIconRef}>
        <IconButton onClick={onClickNotifyImage}>
          {
            userNotifyListState.some(x => x.IsRead === false) ?
            <Badge
              badgeContent=''
              color='error'
              anchorOrigin={{ //左上に配置
                vertical: 'top',
                horizontal: 'left'
              }}
              sx={{
                '& .MuiBadge-badge': { //微調整
                  top: 8,
                  left: 7,
                  height: '12px',
                  minWidth: '12px',
                  borderRadius: '50%',
                  padding: 0,
                },
              }}
            >
              <MyMImage
                screenId={screenId}
                filePath={controlSettings.ImageList.imgNotificationBell}
              />
            </Badge>
              :
              <MyMImage
                screenId={screenId}
                filePath={controlSettings.ImageList.imgNotificationBell}
              />
          }
        </IconButton>
      </Box>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={closeNotify}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        disableScrollLock
        sx={{ pointerEvents: 'none' }}
      >
        <Box
          sx={{
            pointerEvents: 'all !important',
            'hr': {
              borderColor: '#777'
            }
          }}
          ref={notifyAreaRef}
        >
          <Box sx={{ p: 1 }}>
            <IconButton onClick={closeNotify} style={{ position: 'relative', left: '85%' }}>
              <CloseIcon sx={{ fontSize: '30px' }} />
            </IconButton>
            <MyMLabel className='fw-bold' fontSize={18}>{controlSettings.LabelList.lblNotificationHeader}</MyMLabel>
          </Box>
          <Divider />
          <List
            sx={{ maxHeight: 500, maxWidth: 500, overflow: 'auto', paddingTop: 0 }}
            onScroll={updateReadStatus}
          >
            {userNotifyList.length > 0
              ? userNotifyList.map((x, i) => (
                <React.Fragment key={i}>
                  <ListItem className='notification-item'
                    // 未読通知時のスタイル指定
                    sx={!x.IsRead
                      ? {
                        backgroundColor: '#CFF6FF',
                        'p': { color: 'gray' }
                      }
                      : {}}>
                    <Stack direction='column' className="w-100" spacing={1}>
                      <Stack direction='row'>
                        <MyMLabel className='w-100 fw-bold'>{x.Title}</MyMLabel>
                        <MyMLabel sx={{ minWidth: 150 }} align='right'>{utility.convertEnglishDateFormat(x.PublishDate)}</MyMLabel>
                      </Stack>
                      <MyMLabel>{x.Message}</MyMLabel>
                      {x.Url && <MyMLink href={x.Url} target='_blank' component='a'>{controlSettings.LabelList.lnkSeeMore}</MyMLink>}
                    </Stack>
                  </ListItem>
                  {i < userNotifyList.length - 1 && <Divider />}
                </React.Fragment>
              ))
              : <ListItem><MyMLabel>{controlSettings.LabelList.lblNotificationMessage}</MyMLabel></ListItem>
            }
          </List>

        </Box>
      </Popover>
    </Box>
  );
}

/** 
 * HeaderBarSurveyNotify Component
 */
export const HeaderBarSurveyNotify = (props) => {
  const { controlSettings, notify, setNotify, screenId } = props;
  const surveyNotify = notify.SurveyNotify;
  const onClickAnsweredSurveyResultIcon = () => {
    const subWindow = window.open(`${process.env.PUBLIC_URL}/MyM802/${surveyNotify.SurveyId}`, '_blank');

    // 未読のSurveyの場合、ページのロード後に既読にする
    if (surveyNotify.IsReadSurvey === false) {
      subWindow.addEventListener('load', () => {
        notify.SurveyNotify.IsReadSurvey = true;
        setNotify({ ...notify })
      })
    }
  }

  if (surveyNotify) {
    if (surveyNotify.IsCurrentSurvey)
      // Survey期間中
      return surveyNotify.IsAnswered
        // 期間中Surveyが回答済みの場合
        ?
        <MyMTooltip title={controlSettings.LabelList.lblAnswerResultTooltip}>
          <MyMTooltip >
            <IconButton onClick={() => window.open(`${process.env.PUBLIC_URL}/MyM801?surveyId=${surveyNotify.SurveyId}`, '_blank')} >
              <Badge

                badgeContent={<CheckIcon sx={{ width: 10 }} />}
                color='success'
                anchorOrigin={{ //左上に配置
                  vertical: 'top',
                  horizontal: 'left'
                }}
                sx={{
                  '& .MuiBadge-badge': { //微調整
                    top: 6,
                    left: 6,
                    height: '12px',
                    minWidth: '12px',
                    borderRadius: '50%',
                    padding: 0,
                  },
                }}
              >
                <MyMImage
                  screenId={screenId}
                  filePath={controlSettings.ImageList.imgUserSurvey}
                />
              </Badge>
            </IconButton>
          </MyMTooltip>
        </MyMTooltip>
        // 期間中Surveyが未回答の場合
        :
        <MyMTooltip title={controlSettings.LabelList.lblAnswerTooltip}>
          <IconButton onClick={() => window.open(`${process.env.PUBLIC_URL}/MyM801?surveyId=${surveyNotify.SurveyId}`, '_blank')}>
            <Badge
              badgeContent=''
              color='error'
              anchorOrigin={{ //左上に配置
                vertical: 'top',
                horizontal: 'left'
              }}
              sx={{
                '& .MuiBadge-badge': { //微調整
                  top: 6,
                  left: 6,
                  height: '12px',
                  minWidth: '12px',
                },
              }}
            >
              <MyMImage
                screenId={screenId}
                filePath={controlSettings.ImageList.imgUserSurvey}
              ></MyMImage>
            </Badge>
          </IconButton>
        </MyMTooltip>
    else
      // Survey期間外
      return surveyNotify.IsAnswered
        // 前回Surveyが回答済みの場合
        ?
        <MyMTooltip title={controlSettings.LabelList.lblSurveyResultTooltip}>
          <IconButton onClick={onClickAnsweredSurveyResultIcon}>
            {!surveyNotify.IsReadSurvey ?
              <Badge
                badgeContent=''
                color='error'
                anchorOrigin={{ //左上に配置
                  vertical: 'top',
                  horizontal: 'left'
                }}
                sx={{
                  '& .MuiBadge-badge': { //微調整
                    top: 6,
                    left: 6,
                    height: '12px',
                    minWidth: '12px',
                  },
                }}
              >
                <MyMImage
                  screenId={screenId}
                  filePath={controlSettings.ImageList.imgUserSurvey}
                />
              </Badge>
              :
              <MyMImage
                screenId={screenId}
                filePath={controlSettings.ImageList.imgUserSurvey}
              />
            }
          </IconButton>
        </MyMTooltip>
        : <></>
  }
}